// import { Loading } from '@/components/shared';
// import { Alert, Button, Dialog, Notification as Notify, Spinner, toast } from '@/components/ui';
// import { LAYOUT_TYPE_BLANK, LAYOUT_TYPE_CLASSIC, LAYOUT_TYPE_DECKED, LAYOUT_TYPE_MODERN, LAYOUT_TYPE_SIMPLE, LAYOUT_TYPE_STACKED_SIDE } from '@/constants/theme.constant';
// import { handleGetFirebaseToken, onForegroundMessage } from '@/firebase';
// import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
// import { setThemeColor, setThemeColorLevel } from '@/store/theme/themeSlice';
// import { getNotificationsThunk } from '@/store/notification/notification-slice';
// import useAuth from '@/utils/hooks/useAuth';
// import useDirection from '@/utils/hooks/useDirection';
// import useLocale from '@/utils/hooks/useLocale';
// import { appendOrderList } from '@/views/ordermanagement/Orders/store/dataSlice';
// import { Howl } from 'howler';
// import React, { Suspense, lazy, memo, useEffect, useMemo, useRef } from 'react';
// import { useSelector } from 'react-redux';

// const layouts = {
//   [LAYOUT_TYPE_CLASSIC]: lazy(() => import('./ClassicLayout')),
//   [LAYOUT_TYPE_MODERN]: lazy(() => import('./ModernLayout')),
//   [LAYOUT_TYPE_STACKED_SIDE]: lazy(() => import('./StackedSideLayout')),
//   [LAYOUT_TYPE_SIMPLE]: lazy(() => import('./SimpleLayout')),
//   [LAYOUT_TYPE_DECKED]: lazy(() => import('./DeckedLayout')),
//   [LAYOUT_TYPE_BLANK]: lazy(() => import('./BlankLayout')),
// };

// const sound = new Howl({ src: ['/audio/ring.mp3'], volume: 1 });

// const Layout = () => {
//   const dispatch = useAppDispatch();
//   const layoutType = useSelector((state) => state.theme.layout.type);
//   const { signedIn, isSigningOut } = useAppSelector((state) => state.auth.session);
//   const { fcmPermissionLoading, showNotificationPermissionBanner } = useAppSelector((state) => state.firebaseConfig);
//   const userId = useAppSelector((state) => state.auth.user.id);
//   const { authenticated } = useAuth();
//   const businessInfoData = useAppSelector((state) => state.businessInfo.businessInfoData);
//   const chatwootInitialized = useRef(false);

//   useDirection();
//   // useLocale();

//   const AppLayout = useMemo(() => {
//     if (authenticated) return layouts[layoutType];
//     return lazy(() => import('./AuthLayout'));
//   }, [layoutType, authenticated]);

//   // Chatwoot SDK initialization
//   const initializeChatwoot = () => {
//     if (chatwootInitialized.current || !authenticated) return;

//     const BASE_URL = "https://agentx.megnus.app";
//     const script = document.createElement('script');

//     script.src = BASE_URL + "/packs/js/sdk.js";
//     script.defer = true;
//     script.async = true;

//     script.onload = function () {
//       if (window.chatwootSDK) {
//         window.chatwootSDK.run({
//           websiteToken: 'AEYRggcAs2x27rqYbGagXNYQ',
//           baseUrl: BASE_URL
//         });
//         chatwootInitialized.current = true;
//       }
//     };

//     script.onerror = function () {
//       console.error('Failed to load Chatwoot SDK');
//     };

//     document.head.appendChild(script);
//   };

//   const playSound = () => {
//     const soundInstance = sound.play();
//     return soundInstance;
//   };

//   const openNotification = (type, title, body) => {
//     playSound();
//     setTimeout(() => sound.stop(), 5000);

//     toast.push(
//       <Notify title={title} type={type}>
//         {body}
//       </Notify>
//     );
//   };

//   const showNotification = async (notification) => {
//     const notificationTitle = notification.title;
//     const notificationOptions = { body: notification.body, icon: '/logo192.png' };
//     if ('Notification' in window) new Notification(notificationTitle, notificationOptions);
//     else console.log('Notification API not supported');
//   };

//   const handleForegroundMessage = async (payload) => {
//     if ('Notification' in window) {
//       if (Notification.permission === 'granted') openNotification('success', payload.notification.title, payload.notification.body);
//       else if (Notification.permission !== 'denied') {
//         Notification.requestPermission().then((permission) => {
//           if (permission === 'granted') openNotification('success', payload.notification.title, payload.notification.body);
//         });
//       }
//     }

//     dispatch(getNotificationsThunk({ authId: userId }));

//     if (payload.data?.type === 'order') dispatch(appendOrderList(payload.data));
//   };

//   const onThemeColorChange = ({ value }) => {
//     dispatch(setThemeColor(value));
//   };

//   const onThemeColorLevelChange = ({ value }) => {
//     dispatch(setThemeColorLevel(value));
//   };

//   useEffect(() => {
//     const unsubscribe = onForegroundMessage(handleForegroundMessage);
//     return () => {
//       if (typeof unsubscribe === 'function') unsubscribe();
//     };
//   }, [signedIn]);

//   useEffect(() => {
//     if (businessInfoData) {
//       if (businessInfoData.backgroundColor) onThemeColorChange({ value: businessInfoData.backgroundColor });
//       if (businessInfoData.colorWeight) onThemeColorLevelChange({ value: Number(businessInfoData.colorWeight) });
//     }
//   }, [businessInfoData]);

//   // Initialize Chatwoot when user is authenticated
//   useEffect(() => {
//     if (authenticated && signedIn) {
//       initializeChatwoot();
//     }
//   }, [authenticated, signedIn]);

//   const styleRef = useRef(null);
//   useEffect(() => {
//     if (!styleRef.current) {
//       styleRef.current = document.createElement('style');
//       styleRef.current.type = 'text/css';
//       document.head.appendChild(styleRef.current);
//     }

//     if (businessInfoData?.customCss) {
//       styleRef.current.innerHTML = businessInfoData.customCss;
//     }
//   }, [businessInfoData?.customCss]);

//   return (
//     <Suspense
//       fallback={
//         <div className="flex flex-auto flex-col h-[100vh]">
//           <Loading loading={true} />
//         </div>
//       }
//     >
//       {/* {signedIn &&
//         typeof Notification !== 'undefined' &&
//         showNotificationPermissionBanner &&
//         (Notification.permission === 'denied' ? (
//           <Alert className="mb-1" type="warning" showIcon closable>
//             <div>
//               Notifications permission has been blocked. Please reset the permission in Page Info (click the lock icon next to the URL) to allow notifications. For more information, visit <a href="https://www.chromestatus.com/feature/6443143280984064">ChromeStatus</a>.
//             </div>
//           </Alert>
//         ) : (
//           <Alert className="mb-1" type="info" showIcon closable>
//             Please allow us to send notifications to your device for important updates and information
//             <Button className="ml-4 " variant="solid" loading={fcmPermissionLoading} onClick={() => handleGetFirebaseToken(dispatch, userId)}>
//               Allow Permission
//             </Button>
//           </Alert>
//         ))} */}
//       <AppLayout />
//       <Dialog isOpen={isSigningOut} shouldCloseOnOverlayClick={false} shouldCloseOnEsc={false} closable={false} style={{ content: { marginTop: 300 } }} contentClassName="bg-transparent shadow-none flex items-center justify-center">
//         <Spinner size={50} />
//       </Dialog>
//     </Suspense>
//   );
// };

// export default memo(Layout);

import { Loading } from '@/components/shared';
import { Alert, Button, Dialog, Notification as Notify, Spinner, toast } from '@/components/ui';
import { LAYOUT_TYPE_BLANK, LAYOUT_TYPE_CLASSIC, LAYOUT_TYPE_DECKED, LAYOUT_TYPE_MODERN, LAYOUT_TYPE_SIMPLE, LAYOUT_TYPE_STACKED_SIDE } from '@/constants/theme.constant';
import { handleGetFirebaseToken, onForegroundMessage } from '@/firebase';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import { setThemeColor, setThemeColorLevel } from '@/store/theme/themeSlice';
import { getNotificationsThunk } from '@/store/notification/notification-slice';
import useAuth from '@/utils/hooks/useAuth';
import useDirection from '@/utils/hooks/useDirection';
import useLocale from '@/utils/hooks/useLocale';
import { appendOrderList } from '@/views/ordermanagement/Orders/store/dataSlice';
import { Howl } from 'howler';
import React, { Suspense, lazy, memo, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

const layouts = {
  [LAYOUT_TYPE_CLASSIC]: lazy(() => import('./ClassicLayout')),
  [LAYOUT_TYPE_MODERN]: lazy(() => import('./ModernLayout')),
  [LAYOUT_TYPE_STACKED_SIDE]: lazy(() => import('./StackedSideLayout')),
  [LAYOUT_TYPE_SIMPLE]: lazy(() => import('./SimpleLayout')),
  [LAYOUT_TYPE_DECKED]: lazy(() => import('./DeckedLayout')),
  [LAYOUT_TYPE_BLANK]: lazy(() => import('./BlankLayout')),
};

const sound = new Howl({ src: ['/audio/ring.mp3'], volume: 1 });

const Layout = () => {
  const dispatch = useAppDispatch();
  const layoutType = useSelector((state) => state.theme.layout.type);
  const { signedIn, isSigningOut } = useAppSelector((state) => state.auth.session);
  const { fcmPermissionLoading, showNotificationPermissionBanner } = useAppSelector((state) => state.firebaseConfig);
  const userId = useAppSelector((state) => state.auth.user.id);
  const { authenticated } = useAuth();
  const businessInfoData = useAppSelector((state) => state.businessInfo.businessInfoData);
  useDirection();
  // useLocale();

  const AppLayout = useMemo(() => {
    if (authenticated) return layouts[layoutType];
    return lazy(() => import('./AuthLayout'));
  }, [layoutType, authenticated]);

  const playSound = () => {
    const soundInstance = sound.play();
    return soundInstance;
  };

  const openNotification = (type, title, body) => {
    playSound();
    setTimeout(() => sound.stop(), 5000);

    toast.push(
      <Notify title={title} type={type}>
        {body}
      </Notify>
    );
  };
  const showNotification = async (notification) => {
    const notificationTitle = notification.title;
    const notificationOptions = { body: notification.body, icon: '/logo192.png' }; // Replace with the path to the notification icon
    if ('Notification' in window) new Notification(notificationTitle, notificationOptions);
    else console.log('Notification API not supported');
  };
  const handleForegroundMessage = async (payload) => {
    if ('Notification' in window) {
      if (Notification.permission === 'granted') openNotification('success', payload.notification.title, payload.notification.body);
      else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') openNotification('success', payload.notification.title, payload.notification.body);
        });
      }
    }

    dispatch(getNotificationsThunk({ authId: userId })); // Update notifications reducer whenever get new notification

    // Update the order list with the new order data
    if (payload.data?.type === 'order') dispatch(appendOrderList(payload.data));
  };
  const onThemeColorChange = ({ value }) => {
    dispatch(setThemeColor(value));
  };

  const onThemeColorLevelChange = ({ value }) => {
    dispatch(setThemeColorLevel(value));
  };
  useEffect(() => {
    const unsubscribe = onForegroundMessage(handleForegroundMessage);
    // Clean up the listener when the component is unmounted or when the signedIn state changes
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, [signedIn]);
  useEffect(() => {
    if (businessInfoData) {
      if (businessInfoData.backgroundColor) onThemeColorChange({ value: businessInfoData.backgroundColor });
      if (businessInfoData.colorWeight) onThemeColorLevelChange({ value: Number(businessInfoData.colorWeight) });
    }
  }, [businessInfoData]);
  const styleRef = useRef(null);
  useEffect(() => {
    if (!styleRef.current) {
      styleRef.current = document.createElement('style');
      styleRef.current.type = 'text/css';
      document.head.appendChild(styleRef.current);
    }

    if (businessInfoData?.customCss) {
      styleRef.current.innerHTML = businessInfoData.customCss;
    }
  }, [businessInfoData?.customCss]);
  return (
    <Suspense
      fallback={
        <div className="flex flex-auto flex-col h-[100vh]">
          <Loading loading={true} />
        </div>
      }
    >
      {/* {signedIn &&
        typeof Notification !== 'undefined' &&
        showNotificationPermissionBanner &&
        (Notification.permission === 'denied' ? (
          <Alert className="mb-1" type="warning" showIcon closable>
            <div>
              Notifications permission has been blocked. Please reset the permission in Page Info (click the lock icon next to the URL) to allow notifications. For more information, visit <a href="https://www.chromestatus.com/feature/6443143280984064">ChromeStatus</a>.
            </div>
          </Alert>
        ) : (
          <Alert className="mb-1" type="info" showIcon closable>
            Please allow us to send notifications to your device for important updates and information
            <Button className="ml-4 " variant="solid" loading={fcmPermissionLoading} onClick={() => handleGetFirebaseToken(dispatch, userId)}>
              Allow Permission
            </Button>
          </Alert>
        ))} */}
      <AppLayout />
      <Dialog isOpen={isSigningOut} shouldCloseOnOverlayClick={false} shouldCloseOnEsc={false} closable={false} style={{ content: { marginTop: 300 } }} contentClassName="bg-transparent shadow-none flex items-center justify-center">
        <Spinner size={50} />
      </Dialog>
    </Suspense>
  );
};

export default memo(Layout);
